import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    wrapper: {
        width: 1,
        height: 40,
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        background: "#FFFFFF26",
    },
});
